// The one shimmer primitive the skeletons are built from. Everything is an
// explicit box so a placeholder can be sized against the real element it stands
// in for — antd's Skeleton.Input/paragraph only offer preset heights, which is
// what made the first pass collapse the 77px thumbnail cell into a thin bar.
const Bar = ({ w, h = 12, r = 4, className = "" }) => (
  <div
    className={`animate-pulse bg-light_gray ${className}`}
    style={{ width: w, height: h, borderRadius: r }}
  />
);

export default Bar;
